export default {
  metaTitleBrand: "LOYA SPORT",
  metaTitleHome: "Главная",
  metaTitleProducts: "Товары",
  metaTitleProductDetail: "Детали товара",
  metaTitleCustomService: "Индивидуальный сервис",
  metaTitleSolutions: "Решения",
  metaTitleAbout: "О компании",
  metaTitleContact: "Связаться с нами",
  metaTitleBlog: "Блог",
  metaTitleLogin: "Вход",
  metaTitleAdmin: "Панель администратора",
  metaTitleSystemSetup: "Настройка системы",

  contactDocsTitle: "Доступные документы",
  contactDocsDesc: "Инвойс, упаковочный лист и координация отгрузки.",
  contactSampleTitle: "Сервис образцов",
  contactSampleDesc: "Быстрая организация образцов для OEM и private label проектов.",

  searchOverlayPlaceholder: "Поиск товаров по названию...",
  searchOverlaySubmitAria: "Отправить поиск",
  searchOverlaySubmitTitle: "Поиск",
  searchOverlayHintPrefix: "Нажмите",
  searchOverlayHintSuffix: "чтобы увидеть все подходящие товары или выбрать быстрый результат ниже.",
  searchOverlayCloseAria: "Закрыть поиск",
  searchOverlayQuickResults: "Быстрые результаты",
  searchOverlayQuickResultsAria: "Быстрые результаты поиска",
  searchOverlayFallbackCategory: "Аксессуары для йоги",
  searchOverlayHistory: "История поиска",
  searchOverlayClear: "Очистить",
  searchOverlayNoHistory: "Недавних запросов нет",
  searchOverlayRecommended: "Рекомендуемые ключевые слова",
  searchOverlayFallbackKeyword: "Коврик для йоги",

  blogHeroKicker: "Контент-центр",
  blogHeroTitle: "Инсайты и руководства по закупкам",
  blogSearchAria: "Поиск по статьям",
  blogReadingTimeMin: "мин чтения",
  blogShowLess: "Свернуть",
  blogCategoryAria: "Категории статей",
  blogFeaturedPlaceholder: "Рекомендуемый материал",
  blogPaginationAria: "Пагинация блога",
  blogCtaAria: "Призыв к действию в блоге",
  blogCtaDescription: "Наша команда даст практические рекомендации и сопроводит от этапа образцов до массовой поставки.",
  blogCtaPrimary: "Связаться сейчас",
  blogCtaSecondary: "Смотреть решения",

  requestFreeSample: "Запросить бесплатный образец",

  factoryStatsSince: "Экспорт с 2008 года",
  factoryStatsCapacity: "10 000+ единиц в месяц",
  factoryStatsExport: "Поставки в 50+ стран",
  factoryStatsCert: "Сертификация ISO 9001 и BSCI",

  aboutHeroTitle: "Молодые, профессиональные, сфокусированные — ваши эксперты по интеграции цепочки поставок товаров для йоги",
  aboutHeroBody: "LOYA SPORT находится в Чанше, Хунань, Китай, и располагает энергичной профессиональной командой. Мы помогаем зарубежным покупателям с интеграцией цепочки поставок товаров для йоги — от отбора фабрик-источников до глубокой кастомной разработки.",
  aboutAddress: "Адрес: Ruihe Kechuang Building, Wanglong Road, район Юэлу, Чанша, Хунань, Китай",
  aboutTeamTitle: "Энергичная и профессиональная команда",
  aboutTeamBody: "Мы молоды, но опытны и глубоко понимаем рыночные потребности и технические детали в индустрии йоги. Благодаря строгой логике отбора и высокой скорости реакции мы гарантируем, что каждый поставляемый продукт соответствует высоким коммерческим ожиданиям.",
  aboutCustomizationTitle: "Комплексные услуги кастомизации",
  aboutCustomizationBody: "От печати логотипа и дизайна упаковки до разработки функциональных форм продукта — мы предоставляем гибкие и глубокие решения по кастомизации, чтобы ваш бренд выделялся на рынке.",
  aboutFactoryPartnerTitle: "Премиальные производственные партнёры",
  aboutFactoryPartnerBody: "Мы тесно сотрудничаем с производственными базами, сертифицированными по ISO/BSCI, и контролируем качество с самого источника, чтобы обеспечить стабильность производства и своевременную поставку.",
  aboutHeroKicker: "Интегратор цепочки поставок",
  aboutMetric1: "единое окно проекта для коммуникации по продукту, упаковке и доставке",
  aboutMetric2: "ресурсы фабрик координируются в рамках единой структуры закупки и сопровождения",
  aboutMetric3: "рабочий процесс создан для импортёров, ритейлеров, дистрибьюторов и private label покупателей",
  aboutPlaceholderNote: "Наша задача — сократить разрозненную коммуникацию между покупателем, поставщиком и производственными командами, чтобы проекты двигались понятнее и с меньшим числом слепых зон.",
  aboutHeroImageAlt: "Встреча по координации цепочки поставок для экспортных покупателей",
  aboutHeroCaption: "От запроса до отгрузки мы координируем детали, которые обычно распределены между агентами по закупке, фабриками и логистическими контактами.",
  aboutOfficeImageAlt: "Офисное здание Changsha Loya Technology",
  aboutOfficeCaption: "Офис Changsha Loya Technology",
  aboutTeamImageAlt: "Наша профессиональная команда в офисе Чанши",
  aboutFactoryImageAlt: "Линия производства ковриков для йоги и процесс контроля качества",
  aboutFactoryCollageAlt: "Склад фабрики и производственные детали",
  aboutWhatWeDoTitle: "Что мы реально делаем",
  aboutWhatWeDoBody1: "Многим покупателям нужен не просто каталог. Им нужен партнёр, который сможет связать коммерческие требования с реальным исполнением на фабрике. Именно здесь мы и работаем. Мы координируем выбор поставщиков, обсуждение цен, подготовку образцов, выполнение упаковки, сопровождение производства, согласование инспекций и готовность к экспорту.",
  aboutWhatWeDoBody2: "Вместо того чтобы оставлять детали продукта, файлы упаковки, сроки поставки и изменения заказа у разных контактов, мы централизуем процесс и ведём проект через единый ответственный канал коммуникации.",
  aboutBadge1: "Подбор поставщиков",
  aboutBadge2: "Сопровождение образцов",
  aboutBadge3: "Исполнение упаковки",
  aboutBadge4: "Готовность к отгрузке",
  aboutSideImageAlt: "Коммуникация с покупателем и обзор проекта",
  aboutIntegratedCapabilitiesTitle: "Интегрированные возможности снабжения",
  aboutSideCaption: "Мы сосредоточены на том, чтобы сделать цепочку поставок проще для зарубежных покупателей, которым важнее надёжная координация, чем разрозненная торговая активность.",
  aboutCapabilityCard1Title: "Интеграция сети поставщиков",
  aboutCapabilityCard1Body: "Мы объединяем фабричные ресурсы, знание категорий и контроль закупок в единый клиентский рабочий процесс, чтобы вам не приходилось самостоятельно координировать несколько сторон.",
  aboutCapabilityCard2Title: "Коммерческая и техническая координация",
  aboutCapabilityCard2Body: "От коммерческого предложения, образцов и деталей упаковки до подтверждения спецификаций и контрольных точек производства — мы удерживаем коммерческую и производственную стороны в едином контуре.",
  aboutCapabilityCard3Title: "Исполнение экспортных заказов",
  aboutCapabilityCard3Body: "Мы сопровождаем заказы через инспекцию, документы, бронирование и готовность к отгрузке, чтобы сократить коммуникационные разрывы и риски поставки.",
  aboutOperatingModel1: "Подбор категории и фабрики на основе вашего целевого рынка и ценового позиционирования.",
  aboutOperatingModel2: "Образцы, проверка спецификаций и координация упаковки до окончательной фиксации производства.",
  aboutOperatingModel3: "Сопровождение производства, контроль качества и подготовка к отгрузке в рамках единого проектного потока.",
  aboutOperatingModel4: "Единое окно коммуникации по продукту, упаковке, документации и ходу поставки.",
  aboutWhoWeServeTitle: "Кому мы помогаем",
  aboutBuyerScenario1Title: "Для импортёров и дистрибьюторов",
  aboutBuyerScenario1Body: "Мы помогаем консолидировать продуктовые линии, сравнивать варианты поставщиков и выстраивать более стабильный план пополнения ассортимента по категориям.",
  aboutBuyerScenario2Title: "Для розничных сетей и e-commerce продавцов",
  aboutBuyerScenario2Body: "Мы поддерживаем готовые к запуску ассортиментные наборы, упаковку private label и практичную коммуникацию для повторяемых заказов.",
  aboutBuyerScenario3Title: "Для брендов, расширяющих линейку",
  aboutBuyerScenario3Body: "Мы выступаем координационным слоем между вашей идеей, производством и экспортным исполнением, чтобы внутренние команды двигались быстрее.",
  aboutWorkflowTitle: "Как устроен наш рабочий процесс",
  aboutWorkflowStep1: "Сбор требований и уточнение целевого продукта",
  aboutWorkflowStep2: "Подбор поставщика, коммерческое предложение и планирование образцов",
  aboutWorkflowStep3: "Проверка спецификаций, упаковки и соответствия требованиям",
  aboutWorkflowStep4: "Сопровождение производства, инспекция и готовность к отгрузке",
  aboutWhyIntegratorTitle: "Почему покупатели выбирают интегратора цепочки поставок",
  aboutWhyIntegratorBody1: "Когда закупка затрагивает нескольких поставщиков, подрядчиков по упаковке и разные графики отгрузки, самый большой риск обычно не в первом предложении. Он возникает, когда после старта заказа теряется согласованность.",
  aboutWhyIntegratorList1: "Спецификации могут разойтись между коммерческим предложением и производством.",
  aboutWhyIntegratorList2: "Детали упаковки и брендинга могут задержаться из-за фрагментированной коммуникации.",
  aboutWhyIntegratorList3: "Инспекция, документы и подготовка к отгрузке могут оторваться от исходного коммерческого обещания.",
  aboutWhyIntegratorBody2: "Наша ценность — удерживать эти элементы связанными. Мы работаем как координационный слой между ожиданиями покупателя и исполнением поставщика, чтобы решения документировались, сроки контролировались, а риски передачи между этапами снижались.",
  aboutTalkToTeam: "Связаться с нашей командой",
  aboutPositioningTitle: "Наше позиционирование",
  aboutPositioningBody: "LOYA SPORT позиционирует себя как интегратор цепочки поставок для экспортно-ориентированных фитнес-товаров. Мы помогаем клиентам закупать с более ясной координацией, более сильной организацией поставщиков и более управляемым маршрутом от закупки до отгрузки.",

  solutionsHeroKicker: "Решения",
  solutionsHeroTitle: "Выберите подходящий путь закупки для вашего типа покупателя",
  solutionsHeroBody: "Построено как наглядный гид по соответствию каналу, сценарию и планированию товарной программы.",
  solutionsTalkToSales: "Связаться с отделом продаж",
  solutionsBrowseProducts: "Смотреть товары",
  solutionsHeroImageAlt: "B2B решения по закупке для покупателей товаров для йоги и лёгкого фитнеса",
  solutionsHeroBadgeTitle: "Подходящее решение",
  solutionsHeroBadgeBody: "Тип покупателя + сценарий + ассортимент",
  solutionsBuyerTypeTitle: "Решения по типу покупателя",
  solutionsViewMatchingProducts: "Показать подходящие товары",
  solutionsScenarioPlansTitle: "Сценарные планы",
  solutionsProgramMixesTitle: "Рекомендуемые товарные миксы",
  solutionsNextStepKicker: "Следующий шаг",
  solutionsNextStepTitle: "Нужен индивидуальный микс для вашего рынка?",
  solutionsNextStepBody: "Поделитесь своим типом покупателя, целевыми товарами и рынком назначения. Мы предложим практичный маршрут формирования ассортимента.",
  solutionsRequestPlan: "Запросить план решения",
  solutionsExploreOem: "Изучить OEM-поддержку",
  solutionsBuyerCard1Title: "Оптовики",
  solutionsBuyerCard1Subtitle: "Быстрое формирование ассортимента для оптовых программ.",
  solutionsBuyerCard1Need1: "Нужна стабильная оптовая поставка с меньшим риском дефицита",
  solutionsBuyerCard1Need2: "Нужны carton-ready SKU миксы для ускорения перепродажи",
  solutionsBuyerCard1Need3: "Нужны повторяющиеся циклы дозакупки с предсказуемым сроком поставки",
  solutionsBuyerCard1Tag1: "Оптовые ассортименты",
  solutionsBuyerCard1Tag2: "Готовые carton-паки",
  solutionsBuyerCard1Tag3: "Повторное пополнение",
  solutionsBuyerCard2Title: "Ритейлеры",
  solutionsBuyerCard2Subtitle: "Готовые к полке пакеты и стабильное пополнение.",
  solutionsBuyerCard2Need1: "Нужны понятные ценовые ступени от базового до премиального сегмента",
  solutionsBuyerCard2Need2: "Нужна упаковка с готовностью под штрихкод для ускоренного вывода на полку",
  solutionsBuyerCard2Need3: "Нужно надёжное пополнение по быстро оборачиваемым позициям",
  solutionsBuyerCard2Tag1: "Retail-паки",
  solutionsBuyerCard2Tag2: "Поддержка штрихкода",
  solutionsBuyerCard2Tag3: "Миксы для выкладки",
  solutionsBuyerCard3Title: "Фитнес-бренды",
  solutionsBuyerCard3Subtitle: "Программы private label для расширения бренда.",
  solutionsBuyerCard3Need1: "Нужен кастомный брендинг без полной перестройки цепочки поставок",
  solutionsBuyerCard3Need2: "Нужны стили упаковки, соответствующие позиционированию бренда",
  solutionsBuyerCard3Need3: "Нужно сокращение времени от образца до запуска",
  solutionsBuyerCard3Tag1: "Нанесение логотипа",
  solutionsBuyerCard3Tag2: "Индивидуальная упаковка",
  solutionsBuyerCard3Tag3: "Расширение линейки бренда",
  solutionsBuyerCard4Title: "Йога-студии",
  solutionsBuyerCard4Subtitle: "Студийные наборы, аксессуары и комплекты для занятий.",
  solutionsBuyerCard4Need1: "Нужны стартовые наборы для новых участников и пробных занятий",
  solutionsBuyerCard4Need2: "Нужны прочные аксессуары для интенсивного использования",
  solutionsBuyerCard4Need3: "Нужны практичные bundle-цены для апсейл-программ",
  solutionsBuyerCard4Tag1: "Стартовые наборы",
  solutionsBuyerCard4Tag2: "Аксессуары для занятий",
  solutionsBuyerCard4Tag3: "Наборы для апгрейда участников",
  solutionsBuyerCard5Title: "Продавцы Amazon",
  solutionsBuyerCard5Subtitle: "Готовые к маркетплейсам комплекты и упаковка.",
  solutionsBuyerCard5Need1: "Нужна компактная структура bundle для контроля стоимости доставки",
  solutionsBuyerCard5Need2: "Нужны товарные сочетания, удобные для листинга и конверсии",
  solutionsBuyerCard5Need3: "Нужно качество упаковки, снижающее уровень возвратов",
  solutionsBuyerCard5Tag1: "Компактные наборы",
  solutionsBuyerCard5Tag2: "Упаковка для фото",
  solutionsBuyerCard5Tag3: "Лёгкий запуск",
  solutionsBuyerCard6Title: "E-commerce компании",
  solutionsBuyerCard6Subtitle: "Визуально сильные товары для повторяющихся онлайн-продаж.",
  solutionsBuyerCard6Need1: "Нужны hero-SKU, хорошо работающие в рекламе и соцсетях",
  solutionsBuyerCard6Need2: "Нужны гибкие bundle-наборы для роста среднего чека",
  solutionsBuyerCard6Need3: "Нужно быстрое обновление каталога для сезонных кампаний",
  solutionsBuyerCard6Tag1: "Ключевые товары",
  solutionsBuyerCard6Tag2: "Логика комплектов",
  solutionsBuyerCard6Tag3: "Быстрое обновление каталога",
  solutionsScenario1Title: "Стартовые студийные наборы",
  solutionsScenario1Body: "Готовые к запуску наборы для йога-классов, пробных программ и membership-пакетов.",
  solutionsScenario2Title: "Зоны восстановления и массажа",
  solutionsScenario2Body: "Массажные инструменты, роллеры и recovery-аксессуары для фитнес-пространств.",
  solutionsScenario3Title: "Программы розничной выкладки",
  solutionsScenario3Body: "Сбалансированные ассортиментные наборы с упаковкой, подходящей для полочного представления.",
  solutionsScenario4Title: "Онлайн bundle-предложения",
  solutionsScenario4Body: "Компактные наборы, созданные для товарных страниц, ориентированных на конверсию.",
  solutionsProgram1Title: "Студийный стартовый микс",
  solutionsProgram1Body: "Чистый стартовый ассортимент для йога-бизнесов, основанных на занятиях.",
  solutionsProgram1Item1: "Коврики для йоги",
  solutionsProgram1Item2: "Блоки и ремни",
  solutionsProgram1Item3: "Массажные аксессуары",
  solutionsProgram1SuitedFor: "Студии / тренеры",
  solutionsProgram2Title: "Программа для retail-полки",
  solutionsProgram2Body: "Сбалансированное продуктовое семейство для магазинов, которым нужны понятные ценовые уровни и повторные заказы.",
  solutionsProgram2Item1: "Базовые коврики",
  solutionsProgram2Item2: "Аксессуары для пилатеса",
  solutionsProgram2Item3: "Recovery-инструменты импульсного спроса",
  solutionsProgram2SuitedFor: "Ритейлеры / дистрибьюторы",
  solutionsProgram3Title: "Онлайн bundle-пакет",
  solutionsProgram3Body: "Компактные наборы товаров, созданные для PDP-визуалов и более простой онлайн-конверсии.",
  solutionsProgram3Item1: "Мини-наборы",
  solutionsProgram3Item2: "Подарочные пакеты",
  solutionsProgram3Item3: "Вкладыши private label",
  solutionsProgram3SuitedFor: "Amazon / e-commerce",

  contactResponseTitle: "Среднее время ответа",
  contactResponseDesc: "В течение 8 рабочих часов для стандартных RFQ-запросов.",

  carouselLoadingTitle: "Загрузка баннеров",
  carouselLoadingBody: "Мы подготавливаем визуальные материалы для главной страницы. Пожалуйста, подождите немного, пока баннеры загружаются.",
  carouselPlaceholderTitle: "Баннеры подготавливаются",
  carouselPlaceholderBody: "Карусель главной страницы появится здесь, как только ресурсы изображений будут готовы.",

  aboutProductDev: "Разработка продукта",
  aboutProductDevDesc: "Быстрые циклы образцов и практичная совместная работа по дизайну для ускоренного вывода на рынок.",
  aboutSupplyReliability: "Надёжность поставок",
  aboutSupplyReliabilityDesc: "Стабильное снабжение материалами и планирование мощностей помогают удерживать поставки в графике даже в пиковые сезоны.",
  aboutTradeSupport: "Поддержка доставки и after-sales",
  aboutTradeSupportDesc: "Документы, координация отгрузки и постпродажная поддержка для более плавных международных операций.",
  aboutSupplyList1: "Проверенная координация поставщиков для товаров для йоги и лёгкого фитнеса",
  aboutSupplyList2: "Многоэтапная проверка качества с партнёрскими фабриками",
  aboutSupplyList3: "Поддержка private label и упаковки",
  aboutSupplyList4: "Глобальная поддержка поставок по ключевым регионам и каналам",

  oemCapability1: "Индивидуальная печать логотипа, тиснение и лазерная маркировка для основных аксессуаров для йоги.",
  oemCapability2: "Корректировка цвета, материала, текстуры и размера под ваш целевой рынок.",
  oemCapability3: "Упаковка, готовая к retail, вкладыши, штрихкоды и маркировка коробов.",
  oemCapability4: "Разработка наборов для студий, Amazon-ready паков и сезонных акций.",
  oemProcess1Title: "Поделитесь вашей идеей",
  oemProcess1Body: "Отправьте целевые товары, логотипы, референсные изображения, ожидания по упаковке и ориентировочное количество.",
  oemProcess2Title: "Подтвердите спецификации и MOQ",
  oemProcess2Body: "Мы проверим варианты материалов, способ брендинга, требования compliance, срок поставки и реалистичный стартовый объём.",
  oemProcess3Title: "Образцы и доработка",
  oemProcess3Body: "Мы организуем образцы или mockup-варианты, соберём вашу обратную связь и зафиксируем производственный стандарт до внесения депозита.",
  oemProcess4Title: "Массовое производство и инспекция",
  oemProcess4Body: "Производство идёт по утверждённому образцу, с проверкой упаковки и предотгрузочным контролем качества.",

  news1Title: "Выпущен весенний гид по закупкам",
  news1Body: "Изучите последние тренды в категориях йоги, пилатеса и recovery-продуктов для следующего розничного сезона.",
  news2Title: "Обновления OEM-упаковки",
  news2Body: "Теперь мы поддерживаем больше экологичных вариантов коробов, вкладышей и штрихкод-упаковки для private label программ.",
  news3Title: "Уведомление по экспортному графику",
  news3Body: "Планирование сроков и окна отгрузки обновляются еженедельно, чтобы помочь покупателям точнее управлять календарями запусков.",

  navYogaMats: "Коврики для йоги",
  navYogaBlocks: "Блоки для йоги",
  navYogaStraps: "Ремни для йоги",
  navResistanceBands: "Эспандеры",
  navPilatesRings: "Кольца для пилатеса",
  navFoamRollers: "Пенные роллеры",
  navOemPrivateLabel: "Индивидуальный сервис",
  navSolutionsControl: "Решения",
  navBlog: "Блог",
  navCompanyProfile: "О компании",
  navContactUs: "Связаться с нами",
  seeAllCategories: "Смотреть все категории",

  productDetailReady: "Готово для private label",
  productDetailQuote: "Цена по запросу",
  productDetailViewSpecs: "Смотреть характеристики",
  productDetailRequestQuote: "Запросить предложение",

  pdLoadErrorProductDetail: "Не удалось загрузить детали товара",
  pdLoadErrorRelatedProducts: "Не удалось загрузить похожие товары",
  pdLoadErrorStorefrontConfig: "Не удалось загрузить настройки storefront",
  pdLoading: "Загрузка деталей товара...",
  pdSampleDefaultMessage: "Пожалуйста, сообщите условия образцов, сроки и детали предложения.",
  pdAttrProductName: "Название товара",
  pdAttrModelNo: "Модель",
  pdAttrCategory: "Категория",
  pdAttrManufacturer: "Производитель",
  pdLeadTimeOnRequest: "Срок поставки по запросу",
  pdLeadTimeUpTo: "До {qty} шт.: {days} дней",
  pdLeadTimeFrom: "{qty}+ шт.: {days} дней",
  pdLeadTimeDaysOnly: "{days} дней",
  pdContactForQuote: "Свяжитесь для предложения",
  pdPerPiece: "{price} / шт.",
  pdAnonymousBuyer: "Анонимный покупатель",
  pdReviewTipSignIn: "Пожалуйста, войдите как клиент, чтобы голосовать за полезность.",
  pdReviewTipSessionExpired: "Сессия истекла. Пожалуйста, войдите снова, чтобы проголосовать.",
  pdReviewTipNoPermission: "Текущий аккаунт не может голосовать за полезность.",
  pdReviewTipUpdateFailed: "Не удалось обновить статус полезности",
  pdSpecValues: "Значения",
  pdSpecRequired: "Обязательно",
  pdSpecOptional: "Опционально",
  pdCapabilityCustomLogo: "Нанесение логотипа",
  pdCapabilitySampleDev: "Разработка по образцу",
  pdCapabilityPackagingCoordination: "Координация упаковки",
  pdCapabilityExportFollowUp: "Сопровождение экспортной отгрузки",
  pdPackagingSellingUnit: "Единица продажи",
  pdPackagingSingleItem: "Одна единица",
  pdPackagingType: "Упаковка",
  pdPackagingTypeFallback: "OPP-пакет / экспортная коробка",
  pdPackagingLoadingAdvice: "Рекомендации по загрузке",
  pdPackagingLoadingAdviceFallback: "В зависимости от структуры заказа",
  pdPackagingLeadTime: "Срок поставки",
  pdMediaPhotoLabel: "Фото {index}",
  pdMediaVideoLabel: "Видео",
  pdMediaAttributesLabel: "Параметры",
  pdPackagingPointPackaging: "Упаковка: {value}",
  pdPackagingPointLoadingAdvice: "Рекомендации по загрузке: {value}",
  pdPackagingPointShippingPort: "Порт отгрузки: {value} (обсуждается)",
  pdPackagingPointShippingPortNegotiable: "Порт отгрузки: обсуждается",
  pdPackagingPointLeadTime: "Срок поставки: {value}",
  pdInquiryHello: "Здравствуйте, я хотел бы запросить информацию о:",
  pdInquiryProduct: "Товар: {value}",
  pdInquirySku: "SKU: {value}",
  pdInquirySkuName: "Название SKU: {value}",
  pdInquiryModel: "Модель: {value}",
  pdInquiryQuantity: "Количество: {value}",
  pdEmailSubject: "Запрос: {sku} - {name}",
  pdInquirySubmitFailed: "Сейчас не удаётся отправить запрос.",
  pdSampleContactPerson: "Контактное лицо: {value}",
  pdSampleWhatsapp: "WhatsApp/WeChat: {value}",
  pdSampleCompany: "Компания: {value}",
  pdSampleRequestedQuantity: "Запрошенное количество: {value}",
  pdSampleSelectorQuantity: "Выбор количества на странице: {value}",
  pdVariationLabel: "Опция",
  pdVariationInquiryIntro: "Здравствуйте, я хотел бы отправить запрос по товару:",
  pdVariationInquiryQuoteLeadTime: "Пожалуйста, пришлите актуальную цену и срок поставки.",
  pdVideoFallback: "Не удалось загрузить видео. Пожалуйста, попробуйте снова или откройте исходную ссылку напрямую.",
  pdRetry: "Повторить",
  pdOpenVideoUrl: "Открыть ссылку на видео",
  pdProductAttributes: "Характеристики товара",
  pdMediaTabsAria: "Типы медиа товара",
  pdMediaTabPhotos: "Фото",
  pdMediaTabVideo: "Видео",
  pdMediaTabAttributes: "Параметры",
  pdInfoTabsAria: "Вкладки детальной информации",
  pdInfoTabAttributes: "Параметры",
  pdInfoTabDescription: "Описание",
  pdInfoTabSupplier: "Поставщик",
  pdInfoTabReviews: "Отзывы",
  pdKeyAttributes: "Ключевые характеристики",
  pdPackagingShippingInfo: "Упаковка и доставка",
  pdProductDescription: "Описание товара",
  pdSupplierOverview: "Обзор поставщика",
  pdSupplierOverviewHint: "Профиль компании и FAQ показаны под детальными изображениями.",
  pdBuyerFeedback: "Отзывы покупателей",
  pdRepeatBuyer: "Постоянный покупатель",
  pdReviewRatingAria: "Оценка {rating} из 5",
  pdReviewMetaColor: "цвет: {value}",
  pdReviewMetaColorFallback: "второй",
  pdReviewUnavailable: "Этот товар больше недоступен",
  pdReviewHelpful: "Полезно ({count})",
  pdNoReviews: "Для этого товара пока нет отзывов.",
  pdNoReviewsHint: "Свяжитесь с нашей командой для получения референсов заказов или отзывов по образцам.",
  pdTitleFallback: "Детали товара",
  pdCustomizable: "Можно кастомизировать",
  pdVariationCardAria: "Варианты товара",
  pdVariations: "Варианты",
  pdSelectNow: "Выбрать сейчас",
  pdSelectOption: "Выберите вариант",
  pdLadderPricingAria: "Ступенчатые цены",
  pdProductSpecifications: "Спецификации товара",
  pdSpecPrevAria: "Показать предыдущее значение спецификации",
  pdSpecNextAria: "Показать следующее значение спецификации",
  pdSupplierCapability: "Возможности кастомизации поставщика",
  pdGetFreeSample: "Получить бесплатный образец",
  pdWhatsAppInquiry: "Запрос через WhatsApp",
  pdEmailInquiry: "Запрос по email",
  pdPackagingDelivery: "Упаковка и доставка",
  pdProductVideo: "Видео товара",
  pdVideoOpenLink: "Видео не может быть воспроизведено в текущем контексте.",
  pdSupplierDescriptions: "Описание товара от поставщика",
  pdCompanyIntroduction: "О компании",
  pdNoCompanyIntroduction: "Описание компании не настроено.",
  pdFaq: "FAQ",
  pdNoFaq: "FAQ не настроен.",
  pdCloseVariationSelector: "Закрыть выбор вариантов",
  pdVariationSelectAndQty: "Выберите варианты и количество",
  pdVariationStock: " / запас {count}",
  pdSelectedQuantity: "Выбранное количество",
  pdSendInquiry: "Отправить запрос",
  pdChatNow: "Написать сейчас",
  pdOptionLabel: "Опция {index}",
  pdRelatedAria: "Похожие товары",
  pdRelatedTitle: "Похожие товары",
  pdRelatedSubtitle: "Ещё товары, которые часто закупают вместе в этой категории.",
  pdRelatedPrevAria: "Предыдущие похожие товары",
  pdRelatedNextAria: "Следующие похожие товары",
  pdSampleContactTitle: "Пожалуйста, свяжитесь с нами",
  pdSampleContactDesc: "Есть вопросы? Мы рады помочь. Напишите нам в WhatsApp или по email для запроса образца.",
  pdSampleCloseAria: "Закрыть запрос на образец",
  pdSampleSummaryProduct: "Товар",
  pdSampleSummaryQuantity: "Количество",
  pdFormFullName: "Полное имя",
  pdFormFullNamePlaceholder: "Ваше имя",
  pdFormEmail: "Email*",
  pdFormEmailPlaceholder: "Связаться с вами по email",
  pdFormWhatsapp: "WhatsApp/WeChat*",
  pdFormWhatsappPlaceholder: "Связаться с вами через WhatsApp",
  pdFormCompany: "Название вашей компании",
  pdFormCompanyPlaceholder: "Название вашей компании",
  pdFormRequiredQuantity: "Требуемое количество",
  pdFormRequiredQuantityPlaceholder: "Необходимое количество для образца или теста",
  pdFormMessage: "Сообщение",
  pdFormMessagePlaceholder: "Кратко опишите ваши требования к продукту",
  pdFormSending: "Отправка...",
  pdFormSendMessage: "Отправить сообщение",
  pdFormInquirySuccess: "Запрос успешно отправлен.",

  oemHeroKicker: "Индивидуальный сервис",
  oemTitle: "Создайте собственную йога-линейку с понятным производственным процессом",
  oemIntro: "Мы поддерживаем зарубежных покупателей в кастомизации продукта, разработке упаковки, сопровождении образцов и исполнении заказов в категориях йоги и лёгкого фитнеса.",
  oemStartProject: "Начать кастомный проект",
  oemBrowseProducts: "Смотреть базовые товары",
  oemVisualGuide: "Визуальный гид по кастомизации",
  oemVisualAlt: "Опции OEM-кастомизации и руководство по процессу",
  oemVisualPlaceholder: "Изображение кастомизации не найдено. Добавьте файл в frontend/public/assets/about/oem-customization-guide.jpg",
  oemCapabilityKicker: "Что мы можем кастомизировать",
  oemCapabilityTitle: "От нанесения логотипа до полного исполнения упаковки",
  oemProjectBrief: "Краткое описание проекта",
  oemServiceShowcaseAria: "OEM и ODM услуги кастомизации",
  oemServiceShowcaseTitle: "OEM & ODM услуги кастомизации",
  oemServiceShowcaseBody: "Гибкая поддержка под ключ — от оценки концепции до производства и передачи отгрузки.",
  oemCompareHeadBody: "Четыре распространённых пути, показанных как базовый товар и кастомизированный результат.",
  oemCompareBaseSuffix: "базовая версия",
  oemCompareOptionsSuffix: "опции кастомизации",
  oemCompareCustomizedSuffix: "кастомизированная версия",
  oemCompare1Title: "Нанесение логотипа",
  oemCompare1Body: "От стандартного продукта к брендированной подаче.",
  oemCompare1BeforeLabel: "База",
  oemCompare1AfterLabel: "С логотипом",
  oemCompare1CustomizationLabel: "Добавление логотипа",
  oemCompare1Item1: "Печать",
  oemCompare1Item2: "Тиснение",
  oemCompare1Item3: "Лазерная маркировка",
  oemCompare2Title: "Цвет и отделка",
  oemCompare2Body: "От нейтральной спецификации к рыночно подходящему цвету.",
  oemCompare2BeforeLabel: "Стандарт",
  oemCompare2AfterLabel: "Индивидуальный цвет",
  oemCompare2CustomizationLabel: "Обновление цвета",
  oemCompare2Item1: "Цвет",
  oemCompare2Item2: "Текстура",
  oemCompare2Item3: "Размер",
  oemCompare3Title: "Настройка упаковки",
  oemCompare3Body: "От простой упаковки к retail-ready подаче.",
  oemCompare3BeforeLabel: "Простая упаковка",
  oemCompare3AfterLabel: "Готово для retail",
  oemCompare3CustomizationLabel: "Детали упаковки",
  oemCompare3Item1: "Вкладыш",
  oemCompare3Item2: "Штрихкод",
  oemCompare3Item3: "Маркировка короба",
  oemCompare4Title: "Разработка комплектов",
  oemCompare4Body: "От отдельных товаров к готовому комплекту для канала продаж.",
  oemCompare4BeforeLabel: "Отдельные товары",
  oemCompare4AfterLabel: "Комплект",
  oemCompare4CustomizationLabel: "Логика набора",
  oemCompare4Item1: "Студийный набор",
  oemCompare4Item2: "Amazon-пак",
  oemCompare4Item3: "Промо-микс",
  oemCasesTitle: "Кейсы кастомизации",
  oemCase1Title: "Стартовая линейка для boutique-студии",
  oemCase1Summary: "Презентация стартового комплекта для запуска boutique-студии.",
  oemCase1Details: "Комплект с логотипом утверждён за 12 дней.",
  oemCase2Title: "Обновление private label для ритейла",
  oemCase2Summary: "Обновлённый внешний вид упаковки для более чистой полочной презентации.",
  oemCase2Details: "Более быстрое согласование с покупателем и более сильная единообразность в retail.",
  oemCase3Title: "Fitness bundle для маркетплейса",
  oemCase3Summary: "Набор подготовлен для e-commerce и использования в листинге.",
  oemCase3Details: "Вкладыш, штрихкод и проверка массового производства готовы.",
  oemOrderingFlowKicker: "Процесс заказа",
  oemOrderingFlowTitle: "Контакт и заказ в пять шагов",
  oemContactFlow1: "Первичный запрос со списком товаров, целевым рынком и запросом на брендинг.",
  oemContactFlow2: "Коммерческое предложение с планом образца, сроком поставки и вариантами упаковки.",
  oemContactFlow3: "Подтверждение образца и согласование деталей заказа.",
  oemContactFlow4: "Депозит, производство, инспекция и бронирование отгрузки.",
  oemContactFlow5: "Оплата остатка, экспортные документы и post-sales сопровождение.",
  oemContactSideTitle: "Готовы обсудить ваш OEM-запрос?",
  oemContactSideBody: "Отправьте логотип, целевой объём и идею упаковки. Мы предложим практичный маршрут формирования цены и рекомендацию по образцу.",
  oemContactSideNote: "Предпочтительный первый контакт: email или форма запроса с макетом и желаемым окном отгрузки.",
  oemContactSideCta: "Связаться с отделом продаж",

  newsHeroKicker: "Обновления отрасли",
  newsTitle: "Новости и обновления",
  newsIntro: "Следите за нашими последними инсайтами по закупкам, анонсами новых товаров и экспортными обновлениями для покупателей фитнес-аксессуаров.",
  newsSectionTitle: "Для анонсов кастомных проектов или превью новых коллекций свяжитесь с нашей командой продаж, чтобы получить актуальный каталог.",

  contactTitle: "Связаться с поставщиком",
  contactHeroKicker: "Бизнес-запрос",
  contactIntro: "Сообщите нам ваши требования к товару и целевой рынок. Наша команда ответит деталями предложения и оценкой срока поставки.",
  contactFormTitle: "Отправить запрос",
  contactName: "Ваше имя",
  contactEmail: "Рабочий email",
  contactCompany: "Название компании",
  contactMessage: "Спецификации товара, количество, пункт назначения",
  contactSubmit: "Отправить запрос",
  contactSent: "Сообщение успешно отправлено.",
  contactInfoTitle: "Отдел продаж",
  contactInfoEmail: "Email",
  contactInfoPhone: "Телефон",
  contactInfoHours: "Часы работы: Пн-Сб, 09:00-18:00 (GMT+8)",
  contactInfoNote: "Предпочтительные каналы: email для официальных предложений, телефон для срочного подтверждения графика заказа.",
  contactInquiryGreeting: "Здравствуйте, я хотел бы запросить информацию об этом товаре:",
  contactInquiryProductPrefix: "Товар:",
  contactInquiryQuantity: "Количество:",
  contactInquiryDestinationPort: "Порт назначения:",

  aboutTitle: "О LOYA SPORT",
  aboutIntro: "LOYA SPORT — интегратор цепочки поставок товаров для йоги для глобальных B2B покупателей.",
  aboutWhoWeAre: "Кто мы",
  aboutWhoWeAreDesc1: "Мы поддерживаем импортёров, дистрибьюторов, ритейлеров и private label бренды, координируя закупку, образцы, брендинг и сопровождение отгрузки с проверенными supply-партнёрами.",
  aboutWhoWeAreDesc2: "Наша сила — в практичной коммуникации, фокусе на категории и понятном рабочем процессе закупки, который помогает зарубежным клиентам двигаться быстрее.",
  aboutSupplyCapabilities: "Возможности снабжения",
  aboutMission: "Наша миссия",
  aboutMissionDesc: "Помогать фитнес-брендам и розничным покупателям расти за счёт надёжной закупки, строгого контроля качества и полного post-sales сопровождения.",

  navHome: "Главная",
  navProducts: "Товары",
  navCustomization: "Индивидуальный сервис",
  navSolutions: "Решения",
  navAbout: "О компании",
  navContact: "Связаться с нами",

  btnContactUs: "Связаться",
  btnLogin: "Войти",
  btnAccount: "Аккаунт",
  btnQuote: "Запросить предложение",
  btnCurrency: "Валюта",
  btnLanguage: "Язык",

  requestQuote: "Запросить предложение",
  trustTitle: "Глобальные партнёры и доверие",
  factoryStatsSize: "Фабрика 30 000 м²",
  factoryStatsQC: "100% полная проверка качества во время и после производства",
  homeAriaTrust: "Раздел доверия и партнёров",
  homeAriaStats: "Статистика и показатели фабрики",

  authLogin: {
    welcomeBack: "С возвращением",
    brandIntro: "Войдите, чтобы продолжить закупку товаров для йоги и фитнеса.",
    brandBullet1: "Быстрый RFQ-процесс",
    brandBullet2: "Сопровождение товара и заказа",
    brandBullet3: "Поддержка B2B-аккаунта",
    accountLogin: "Вход в аккаунт",
    createAccount: "Создать аккаунт",
    recoverPassword: "Восстановить пароль",
    registrationComplete: "Регистрация завершена",
    passwordUpdated: "Пароль обновлен",
    loginDesc: "Используйте имя пользователя или email и пароль.",
    registerDesc: "Создайте аккаунт с проверкой email и captcha.",
    forgotDesc: "Введите email аккаунта для получения кода сброса.",
    registerSuccessDesc: "Ваш аккаунт успешно создан. Мы автоматически вернёмся на экран входа.",
    resetSuccessDesc: "Ваш пароль успешно обновлён. Мы автоматически вернёмся на экран входа.",
    redirectHintPrefix: "Страница переключится на экран входа через",
    redirectHintSuffix: ".",
    seconds: "секунд",
    loginNow: "Войти сейчас",
    username: "Имя пользователя",
    usernamePlaceholder: "Минимум 3 символа, например loya_buyer",
    usernameHelp: "Имя пользователя должно содержать минимум 3 символа, не должно использовать зарезервированные слова и может включать только буквы, цифры, подчёркивания и дефисы.",
    usernameExistsHint: "Это имя пользователя уже зарегистрировано. Войдите напрямую или выберите другое.",
    usernameExists: "Имя пользователя уже существует. Выберите другое или войдите напрямую.",
    usernameExistsAction: "Имя существует, перейти ко входу",
    usernameAlreadyRegistered: "Это имя пользователя уже зарегистрировано.",
    usernameAvailable: "Имя пользователя доступно.",
    usernameVerifyFailed: "Сейчас невозможно проверить имя пользователя. Попробуйте снова.",
    checkingUsername: "Проверка доступности имени пользователя...",
    email: "Email",
    emailPlaceholder: "your@email.com",
    emailCodeTargetHint: "Введите email, который хотите использовать для получения кода подтверждения.",
    emailExistsHint: "Этот email уже зарегистрирован. Войдите напрямую или используйте другой email.",
    emailExists: "Email уже существует. Используйте другой email или перейдите ко входу.",
    emailExistsAction: "Email существует, перейти ко входу",
    emailAlreadyRegistered: "Этот email уже зарегистрирован.",
    emailAvailable: "Email доступен.",
    emailVerifyFailed: "Сейчас невозможно проверить email. Попробуйте снова.",
    checkingEmail: "Проверка доступности email...",
    usernameOrEmail: "Имя пользователя или Email",
    usernameOrEmailPlaceholder: "имя пользователя или your@email.com",
    forgotEmailHint: "Введите email, привязанный к вашему аккаунту, чтобы мы отправили код сброса.",
    password: "Пароль",
    passwordPlaceholder: "Введите пароль",
    confirmPassword: "Подтвердите пароль",
    confirmPasswordPlaceholder: "Повторно введите пароль",
    confirmNewPassword: "Подтвердите новый пароль",
    confirmNewPasswordPlaceholder: "Повторно введите новый пароль",
    nickname: "Никнейм",
    nicknamePlaceholder: "Необязательно, для отображения",
    captcha: "Captcha",
    registerCaptcha: "Captcha регистрации",
    resetCaptcha: "Captcha сброса",
    refreshCaptcha: "Обновить captcha",
    load: "Загрузить",
    forgotCaptchaHint: "Сначала пройдите captcha, затем запросите код сброса пароля. После отправки автоматически загрузится новая captcha для финального шага.",
    registerCaptchaHint: "Сначала пройдите captcha, затем запросите код подтверждения email.",
    registerStepHint: "Сначала заполните имя пользователя, пароль, подтверждение пароля и корректный email. Затем появится раздел captcha и email-кода.",
    emailCode: "Код из email",
    emailCodePlaceholder: "6-значный код",
    resetCode: "Код сброса",
    resetCodePlaceholder: "6-значный код сброса",
    sending: "Отправка...",
    resendIn: "Повторная отправка через",
    sendEmailCode: "Отправить код на email",
    sendResetCode: "Отправить код сброса",
    signingIn: "Выполняется вход...",
    login: "Войти",
    updating: "Обновление...",
    creating: "Создание...",
    resetPassword: "Сбросить пароль",
    forgotRequirementHint: "Для восстановления пароля требуется captcha и код сброса, отправленный на email.",
    registerRequirementHint: "Для регистрации требуется код подтверждения, отправленный во входящие email.",
    captchaRefreshHint: "Если captcha плохо читается, нажмите на изображение справа, чтобы обновить её.",
    switchToLogin: "Уже есть аккаунт? Войдите сейчас",
    switchToRegister: "Ещё нет аккаунта? Зарегистрируйтесь сейчас",
    backToLogin: "Вернуться ко входу",
    forgotPassword: "Забыли пароль?",
    usernameRequired: "Введите имя пользователя минимум из 3 символов.",
    usernameMin: "Имя пользователя должно содержать минимум 3 символа.",
    usernameMax: "Имя пользователя не может быть длиннее 24 символов.",
    usernamePattern: "Имя пользователя может содержать только буквы, цифры, подчёркивания и дефисы.",
    usernameReserved: "Это имя пользователя зарезервировано. Пожалуйста, выберите другое.",
    usernameFormatOk: "Формат имени пользователя корректен.",
    emailRequired: "Введите email-адрес.",
    emailInvalid: "Введите корректный email-адрес.",
    emailFormatOk: "Формат email корректен.",
    emailProviderHint: "По возможности используйте популярного почтового провайдера, например Gmail, Outlook, QQ Mail, 163, 126 или Foxmail.",
    passwordRequired: "Введите пароль.",
    didYouMean: "Возможно, вы имели в виду",
    passwordMin: "Пароль должен содержать минимум 6 символов.",
    newPasswordMin: "Новый пароль должен содержать минимум 6 символов.",
    confirmPasswordRequired: "Введите подтверждение пароля.",
    passwordMatch: "Пароли совпадают.",
    passwordMismatch: "Пароли не совпадают.",
    emailCodeRequired: "Введите код подтверждения email.",
    resetCodeRequired: "Введите код сброса, отправленный на ваш email.",
    captchaRequired: "Введите код captcha.",
    captchaExpired: "Срок действия капчи истёк. Пожалуйста, обновите страницу и попробуйте снова.",
    captchaIncorrect: "Код капчи неверен. Пожалуйста, попробуйте снова.",
    registerPrerequisitesError: "Сначала заполните имя пользователя, пароль, подтверждение пароля и корректный email, а затем запрашивайте email-код.",
    enterCaptchaBeforeEmailCode: "Сначала введите captcha, затем запрашивайте email-код.",
    enterCaptchaBeforeResetCode: "Сначала введите captcha, затем запрашивайте код сброса пароля.",
    sendEmailCodeFailed: "Не удалось отправить код подтверждения email.",
    emailCodeSent: "Код подтверждения email отправлен.",
    emailCodeSentInbox: "Код подтверждения отправлен на ваш email. Пожалуйста, проверьте входящие.",
    previewCodeCurrentEnv: "Код предварительного просмотра для текущей среды",
    previewCodeDevelopment: "Код предварительного просмотра для разработки",
    previewCodeGenerated: "Код подтверждения email сгенерирован. В этой среде используется код предварительного просмотра.",
    previewCodeContinueRegistration: "Введите этот 6-значный код для продолжения регистрации.",
    tooManyRequests: "Слишком много запросов. Пожалуйста, попробуйте позже.",
    smtpConfigRetry: "Не удалось отправить письмо. Проверьте настройки SMTP и повторите попытку.",
    emailServiceNotConfigured: "Служба доставки email не настроена. Обратитесь к администратору.",
    requestFailed: "Запрос не выполнен. Пожалуйста, попробуйте снова или обратитесь в службу поддержки.",
    registerFailed: "Регистрация не удалась",
    resetFailed: "Сброс пароля не удался",
    loginFailed: "Вход не удался",
    registerSuccessNotice: "Регистрация прошла успешно. Переход на экран входа через примерно 4 секунды.",
    resetSuccessNotice: "Пароль успешно сброшен. Переход на экран входа через примерно 1,5 секунды.",
    loginTokenMissing: "Отсутствует токен входа",
    profileLoadFailed: "Не удалось загрузить профиль аккаунта",
    loginSuccessAdmin: "Вход выполнен успешно. Выполняется переход...",
    loginSuccessStorefront: "Вход выполнен успешно. Выполняется переход в storefront...",
    loginServiceUnavailable: "Сервис входа временно недоступен. Пожалуйста, попробуйте чуть позже.",
    accountNotFound: "Аккаунт не найден. Проверьте имя пользователя или email.",
    passwordIncorrect: "Неверный пароль. Пожалуйста, попробуйте снова.",
    registrationNotOpen: "Вход и регистрация временно закрыты.",
    accountRestricted: "Доступ к этому аккаунту ограничен. Обратитесь к администратору.",
    orContinueWith: "Или продолжить с помощью",
    googleAuthorizing: "Авторизация аккаунта Google...",
    googleFallbackAction: "Продолжить с Google",
    googleAuthFailed: "Аутентификация Google не удалась",
    googleAuthOffline: "Вход через Google временно недоступен в офлайн-режиме. Подключитесь к интернету или войдите с помощью имени пользователя и пароля.",
    googleAuthTimeout: "Время проверки Google истекло. Пожалуйста, повторите попытку. Если ошибки продолжаются, попросите администратора проверить исходящий сетевой доступ бэкенда.",
    googleAuthNetworkError: "Проверка Google не удалась из-за ошибки сети бэкенда. Обратитесь к администратору.",
    googleRegisterSuccess: "Аккаунт Google успешно привязан. Переход в storefront...",
    googleCreateAccountTitle: "Завершение регистрации через Google",
    googleCreateAccountDesc: "Google подтвердил ваш email. Установите пароль для создания аккаунта покупателя и завершения входа.",
    googleCreateAccountHint: "Для этого адреса Google-почты аккаунт ещё не существует. Установите пароль для создания аккаунта покупателя.",
    googleLinkedEmailHint: "Этот подтверждённый адрес Google-почты будет использован для создания аккаунта покупателя.",
    googleCreatePasswordHint: "Установите и подтвердите пароль. Новый аккаунт покупателя будет использовать ваш подтверждённый через Google email.",
    submitLogin: "Войти",
    submitRegister: "Зарегистрироваться",
    submitReset: "Сбросить пароль"
  },

  admin: {
    productCategoryYogaMats: "Коврики для йоги",
    productCategoryYogaBlocks: "Блоки для йоги",
    productCategoryYogaStraps: "Ремни для йоги",
    productCategoryResistanceBands: "Эспандеры",
    productCategoryPilatesRings: "Кольца для пилатеса",
    productCategoryFoamRollers: "Пенные роллеры",
    productCategoryOthers: "Другие",

    faqSampleOrderQ: "Вы принимаете заказы на образцы?",
    faqSampleOrderA: "Да, мы принимаем заказы на образцы, пожалуйста, свяжитесь с нами.",
    faqCustomPackagingQ: "Вы предлагаете индивидуальную упаковку и нанесение логотипа?",
    faqCustomPackagingA: "Да, мы предоставляем индивидуальные OEM/ODM-услуги.",
    faqLeadTimeQ: "Какой у вас срок поставки?",
    faqLeadTimeA: "Обычно от 1 до 3 дней в зависимости от объёма заказа. Финальный срок поставки подтверждается после оформления заказа.",
    faqDefectiveItemQ: "Как обрабатывается дефектный товар?",
    faqDefectiveItemA: "Мы предоставляем гарантию 1 год с даты отгрузки. Если в течение гарантийного периода у вас появится дефект из-за наших материалов или производства, пожалуйста, предоставьте описание, фотографии или видео, а при необходимости и дефектный образец. Наши инженеры проанализируют ситуацию и предложат решение. Если вы хотите оформить возврат, свяжитесь с нами и отправьте товар в оригинальной упаковке с аксессуарами. После получения возврата мы вернём оплату или отправим бесплатную замену.",
    faqWhyChooseUsQ: "Почему стоит выбрать нас?",
    faqWhyChooseUsA: "Наши товары отличаются низким MOQ и высоким качеством, соответствующим стандартам США или ЕС. Мы предоставляем высокий уровень сервиса, поддерживаем OEM и Trade Assurance. Вы можете закупать с уверенностью.",

    companyImageSectionOverview: "Обзор компании",
    companyImageSectionAdvantages: "Конкурентные преимущества",
    companyImageSectionCustomization: "Возможности кастомизации",
    companyImageSectionExtended: "Расширенный профиль компании",
    companyImageSectionPackaging: "Спецификации упаковки и отгрузки",
    companyImageSectionFactory: "Профиль фабрики",
    companyImageSectionWorkflow: "Производственный процесс",
    companyImageSectionTradeShow: "Участие в выставках",

    orderStatusPaid: "Оплачено",
    orderStatusPacked: "Упаковано",
    orderStatusInTransit: "В пути",
    orderStatusDelivered: "Доставлено",
    orderStatusCancelled: "Отменено",

    tabDescHome: "Управляйте рабочими процессами и отслеживайте показатели здесь.",
    tabDescStoreBase: "Настройте адреса фронтенда/админ-панели и SEO-метаданные.",
    tabDescTemplateStudio: "Визуально редактируйте модули макета магазина и сохраняйте пользовательские шаблоны.",
    tabDescArticleManagement: "Управляйте статьями блога в отдельном рабочем пространстве с оконным редактором.",
    tabDescCompanyImages: "Управляйте категориями изображений компании, используемыми в storefront-профиле.",
    tabDescDesignNav: "Настройте фронтенд-навигацию и вложенные структуры меню.",
    tabDescDesignCarousel: "Управляйте баннерами карусели на главной странице.",
    tabDescDesignBanner: "Настройте баннерные сообщения и CTA-контент.",
    tabDescFaqKnowledge: "Поддерживайте базу знаний FAQ для операционных и sales-команд.",
    tabDescProducts: "Управляйте каталогом товаров, деталями и ценообразованием.",
    tabDescProductCreate: "Создавайте новые товары и заполняйте всю информацию и медиа.",
    tabDescMerchandising: "Оценивайте товарных кандидатов, ценовые структуры и готовность к запуску.",
    tabDescProcurement: "Координируйте планы закупки, прогресс поставщиков и приоритеты снабжения.",
    tabDescQuality: "Отслеживайте контрольные точки качества и готовность к выпуску перед исполнением.",
    tabDescLogistics: "Отслеживайте статус отгрузки, подготовку упаковки и координацию логистики.",
    tabDescOrders: "Отслеживайте полный жизненный цикл заказа, исполнение и обновления по доставке.",
    tabDescCustomers: "Управляйте членами команды и правами их аккаунтов.",
    tabDescMarketing: "Просматривайте статус маркетинговых кампаний и показатели роста.",
    tabDescDiscounts: "Управляйте ценовыми стратегиями и правилами акций.",
    tabDescFinance: "Контролируйте финансовые записи и тренды выручки.",
    tabDescFinanceIncome: "Проверяйте поступления по заказам, признанную выручку и записи книги доходов.",
    tabDescFinanceExpenses: "Отслеживайте счета на закупку, логистику, маркетинг и офисные расходы.",
    tabDescFinanceReceivables: "Отслеживайте дебиторскую задолженность, её старение и приоритеты взыскания.",
    tabDescFinancePayables: "Управляйте кредиторской задолженностью, платежами поставщикам и сроками.",
    tabDescFinanceInvoices: "Ведите счета-фактуры, квитанции и статус выставления счетов.",
    tabDescFinanceTax: "Проверяйте исходящий НДС, входящий НДС и налоговые оценки.",
    tabDescFinanceBudget: "Отслеживайте бюджеты, распределение расходов и предупреждения о перерасходе.",
    tabDescFinanceDaily: "Ежедневно суммируйте доходы, расходы и чистые денежные средства компании.",
    tabDescFinanceMonthly: "Закрывайте ежемесячные книги и проверяйте прибыль и отклонение от бюджета.",
    tabDescFinanceYearly: "Проверяйте годовую выручку, расходы, налоги и чистую прибыль.",
    tabDescFinanceReconciliation: "Сверяйте дебиторскую задолженность, поступления, кредиторскую задолженность, счета и налоговое состояние.",
    tabDescFinanceApprovals: "Обрабатывайте аудиты утверждения возвратов, платежей и расходов.",
    tabDescFinanceReports: "Суммируйте финансовые отчёты, операционные показатели и задачи экспорта.",
    tabDescAnalytics: "Анализируйте графические инсайты и операционные метрики.",
    tabDescSettings: "Управляйте основными системными настройками, такими как подключения к базе данных.",
    tabDescWorkTargets: "Отслеживайте и координируйте ежедневные рабочие цели.",
    tabDescWorkProcessing: "Обрабатывайте пользовательские рабочие процессы и журналы исполнения.",
    tabDescHrEmployee: "Просматривайте и поддерживайте карточки сотрудников и данные аккаунтов.",
    tabDescHrRecruitment: "Отслеживайте онбординг и очереди задач по найму.",
    tabDescHrAttendance: "Контролируйте посещаемость сотрудников и активность аккаунтов.",
    tabDescHrOffice: "Управляйте покрытием позиций и внутренними административными задачами.",
    tabDescSiteMaintenance: "Поддерживайте фронтенд-контент и стабильность сайта.",
    tabDescPermissionMaintenance: "Поддерживайте ролевые права и границы доступа.",
    tabDescPositionMaintenance: "Поддерживайте структуру позиций и привязки пользователей.",
    tabDescProfile: "Просматривайте информацию о своём аккаунте.",
    tabDescPassword: "Безопасно изменяйте пароль аккаунта.",
    tabDescInquiry: "Общайтесь с продавцами и отслеживайте обсуждения запросов.",
    tabDescWishlist: "Управляйте сохранёнными товарами и избранными подборками.",
    tabDescOrderProcessing: "Отслеживайте и обрабатывайте записи заказов на всём жизненном цикле.",
    tabDescAfterSales: "Обрабатывайте after-sales-запросы и support-тикеты.",

    roleDeveloper: "Разработчик",
    roleSuperAdmin: "Суперадминистратор",
    roleAdmin: "Администратор",
    roleCustomer: "Клиент",
    roleGuest: "Гость",

    productCreateMenu: "Публикация товара",
    productsMenu: "Список товаров",
    merchandisingOverview: "Обзор merchandising",
    merchandisingCollection: "Пул отбора",
    internalOverview: "Обзор и конфигурация",
    internalWorkspace: "Товар и исполнение",
    internalBusiness: "Продажи и клиенты",
    internalOffice: "Задачи по должностям",
    internalMaintenance: "Панель обслуживания",
    storefrontContent: "Контент storefront",
    guestService: "Сервисы для гостей",
    customerService: "Сервисы для клиентов",
    commonAccount: "Мой аккаунт",
    siteMaintenanceMenu: "Управление позициями",
    positionMaintenanceMenu: "Управление пользователями",

    title: "Мой магазин",
    home: "Операционный обзор",
    storeDesign: "Настройка магазина",
    companyProfile: "Профиль компании",
    storeBase: "Базовые параметры магазина",
    templateStudio: "Студия шаблонов",
    articleManagement: "Управление статьями",
    companyProfileMenu: "Профиль компании",
    companyImages: "Изображения компании",
    designNav: "Меню навигации",
    designCarousel: "Карусель главной страницы",
    designBanner: "Настройки баннера",
    faqKnowledge: "База знаний FAQ",
    products: "Управление товарами",
    productCreate: "Добавить детали товара",
    merchandising: "Центр merchandising",
    procurement: "Центр закупок",
    quality: "Центр качества",
    logistics: "Синхронизация логистики",
    orders: "Запросы и заказы",
    customers: "Управление клиентами",
    marketing: "Маркетинговые кампании",
    discounts: "Ценовые стратегии",
    finance: "Финансовый обзор",
    financeIncome: "Книга доходов",
    financeExpenses: "Счета расходов",
    financeReceivables: "Дебиторская задолженность",
    financePayables: "Кредиторская задолженность",
    financeInvoices: "Управление счетами",
    financeTax: "Управление налогами",
    financeBudget: "Бюджет и расходы",
    financeDaily: "Ежедневные счета",
    financeMonthly: "Ежемесячное закрытие",
    financeYearly: "Годовая отчётность",
    financeReconciliation: "Сверка",
    financeApprovals: "Утверждения и аудит",
    financeReports: "Отчёты и экспорт",
    analytics: "Аналитика данных",
    settings: "Системные настройки",
    menuCommon: "Общее",
    menuInternal: "Внутреннее",
    menuWorkContent: "Рабочий контент",
    menuMaintenance: "Панель обслуживания",
    userManagementGroup: "Панель обслуживания",
    menuGuest: "Гость",
    menuCustomer: "Клиент",
    workTargets: "Рабочие цели",
    workProcessing: "Обработка работы",
    hrEmployee: "Карточки сотрудников",
    hrRecruitment: "Управление наймом",
    hrAttendance: "Управление посещаемостью",
    hrOffice: "Административные задачи",
    siteMaintenance: "Обслуживание позиций",
    permissionMaintenance: "Обслуживание прав",
    positionMaintenance: "Управление пользователями",
    profile: "Личная информация",
    password: "Сменить пароль",
    inquiry: "Чат по запросам",
    wishlist: "Список желаний",
    orderProcessing: "Обработка заказов",
    afterSales: "After-sales сервис",

    profileCardTitle: "Профиль аккаунта",
    accountId: "ID аккаунта",
    profileName: "Имя",
    profileEmail: "Email",
    profileRole: "Роль",
    passwordCardTitle: "Смена пароля аккаунта",
    currentPassword: "Текущий пароль",
    adminResetPasswordHint: "Это предназначено для администраторов, чтобы сбрасывать пароли целевых пользователей. Текущий пароль пользователя не требуется.",
    newPassword: "Новый пароль",
    confirmPassword: "Подтвердите новый пароль",
    savePassword: "Обновить пароль",
    passwordUpdated: "Пароль успешно обновлён.",

    inquiryCardTitle: "Центр запросов",
    inquiryCardBody: "Свяжитесь с отделом продаж, чтобы обсудить требования к товару, цены и график поставки.",
    openInquiryCenter: "Открыть страницу запросов",
    openWhatsappChat: "Чат WhatsApp",

    permissionSectionTitle: "Текущие права",
    permissionSectionBody: "Права выводятся из ответа на вход и структуры позиции.",
    placeholderTodo: "Этот модуль открыт для текущей позиции. Здесь можно расширить конкретные бизнес-операции.",

    systemConfigTitle: "Центр системных настроек",
    settingsTabDatabase: "База данных",
    settingsTabDatabaseHint: "Настройки подключения и пула",
    settingsTabEmail: "Email",
    settingsTabEmailHint: "Брендинг и транзакционные шаблоны",
    mysqlHost: "Хост MySQL",
    mysqlPort: "Порт MySQL",
    mysqlDatabase: "Имя базы данных MySQL",
    mysqlUser: "Имя пользователя MySQL",
    mysqlPassword: "Пароль MySQL",
    mysqlPoolSize: "Размер пула MySQL",
    mysqlConnectTimeoutMs: "Таймаут MySQL (мс)",
    saveSystemConfig: "Сохранить системные настройки",
    systemConfigSavedToast: "Системные настройки сохранены",
    systemConfigPathLabel: "Файл конфигурации",
    restartRequiredHint: "Для применения новых настроек базы данных требуется перезапуск backend-сервиса.",

    storefrontTitle: "Заголовок storefront",
    adminTitle: "Заголовок админ-панели",
    seoMetaTitle: "SEO-заголовок",
    seoDescription: "SEO-описание",
    seoKeywords: "SEO-ключевые слова",
    seoCanonicalUrl: "Канонический URL",
    seoRobots: "SEO Robots",
    seoOgTitle: "Open Graph заголовок",
    seoOgDescription: "Open Graph описание",
    seoOgImage: "URL изображения Open Graph",
    seoTwitterCard: "Тип Twitter Card",
    seoTwitterSite: "Twitter-хэндл сайта",
    saveBaseSettings: "Сохранить базовые настройки",
    baseSavedToast: "Базовые настройки сохранены",

    hello: "Здравствуйте, начнём.",
    askAnything: "Задайте любой вопрос...",
    supportLine: "Есть вопросы? Свяжитесь с поддержкой",
    addStoreName: "Добавить название магазина",
    firstProduct: "Добавьте свой первый товар",
    firstProductDesc: "Начните с добавления товара и заполнения основных деталей.",
    addProduct: "Добавить товар",
    importData: "Импорт",
    customizeStore: "Настройте ваш магазин",
    customizeStoreDesc: "Выберите шаблон и добавьте логотип, цвета и изображения.",
    customTemplate: "Пользовательский шаблон",
    payments: "Настроить коммерческие платежи",
    shipping: "Проверить тарифы доставки",
    domain: "Пользовательский домен",
    quickSales: "Упростите рыночные продажи",
    quickSalesDesc: "Синхронизируйте продажи и управление на нескольких платформах.",
    storeSettings: "Настройки магазина",
    general: "Общее",
    billing: "Биллинг",
    usersPermissions: "Пользователи",

    paginationPrevious: "Назад",
    paginationNext: "Далее",
    paginationPage: "Страница",
    paginationTotal: "из",

    policies: "Политики",
    businessInfo: "Данные бизнеса",
    contactInfo: "Контакты магазина",
    defaults: "Настройки по умолчанию",
    businessMode: "Режим бизнеса",
    b2b: "B2B",
    b2c: "B2C",
    modeSaved: "Режим магазина обновлён",
    modeSavedToast: "Режим бизнеса успешно переключён",

    navSettings: "Меню навигации",
    navLabel: "Подпись подменю",
    navPath: "Ссылка подменю",
    addSubmenu: "Добавить подменю",
    saveNavigation: "Сохранить подменю",
    navSavedToast: "Меню навигации сохранено",

    bannerSettings: "Список баннеров",
    bannerTitle: "Заголовок баннера",
    bannerAnnotation: "Подпись к изображению",
    bannerButtonText: "Текст кнопки",
    bannerButtonLink: "Ссылка кнопки",
    bannerImageUrl: "URL баннера",
    addBanner: "Добавить баннер",
    removeBanner: "Удалить",
    saveBanners: "Сохранить баннеры",
    bannersSavedToast: "Список баннеров сохранён",

    saveFaqKnowledge: "Сохранить FAQ",
    faqKnowledgeSavedToast: "База знаний FAQ сохранена",
    saveCompanyImages: "Сохранить изображения компании",
    companyImagesSavedToast: "Настройки изображений компании сохранены",
    companyIntroductionTitle: "Описание компании",
    companyIntroductionHint: "Используется для отображения профиля компании, преимуществ и сервисных возможностей.",
    companyIntroductionPlaceholder: "Введите текст описания компании...",
    addImageUrl: "Добавить URL изображения",
    uploadLocalImages: "Загрузить локальные изображения",
    addFaq: "Добавить FAQ",
    saveCarouselImages: "Сохранить изображения карусели",
    carouselImagesSavedToast: "Изображения карусели сохранены",

    close: "Закрыть",
    save: "Сохранить",
    create: "Создать",
    search: "Поиск в текущем представлении",
    refresh: "Обновить",
    createProduct: "Добавить товар",
    cancel: "Отмена",
    edit: "Изменить",
    remove: "Удалить",

    systemSnapshot: "Снимок системы",
    activeSearch: "Активный поиск",
    none: "(Нет)",
    orderRecords: "Записи заказов",
    userRecords: "Записи пользователей",
    lastRefresh: "Последнее обновление",
    productsCount: "Товары",
    customersCount: "Клиенты",
    ordersCount: "Заказы",
    revenue: "Выручка USD",

    localeLabel: "Локаль",
    sku: "SKU",
    name: "Название",
    description: "Описание",
    price: "Цена USD",
    imageUrl: "URL изображения",
    category: "Категория",
    model: "Модель",
    titleField: "Заголовок товара",
    detailVideo: "URL детального видео",
    mainImages: "Основные изображения (6 ссылок, по одной на строку)",
    detailImages: "Детальные изображения (по одной ссылке на строку)",
    parameters: "Параметры (ключ:значение на строку)",
    openCreateProduct: "Открыть форму товара",

    id: "ID",
    serialNumber: "#",
    userId: "Пользователь",
    actions: "Действия",
    email: "Email",
    role: "Роль",
    username: "Имя пользователя",
    nickname: "Никнейм",
    userRole: "Роль пользователя",
    phone: "Телефон",
    accountStatus: "Статус аккаунта",
    jobTitle: "Должность",
    registeredAt: "Дата регистрации",
    lastActiveAt: "Последняя активность",
    statusActive: "Активен",
    statusDisactive: "Неактивен",
    permissions: "Права",
    position: "Позиция",
    accessSummary: "Доступ",
    positionName: "Название позиции",
    positionKey: "Ключ позиции",
    department: "Отдел",
    addPosition: "Добавить позицию",
    permissionName: "Название права",
    permissionKey: "Ключ права",
    addPermission: "Добавить право",
    editPermissions: "Изменить права",
    permissionSelectTitle: "Выбрать права",
    permissionSelectedSummary: "Выбрано",
    permissionQuickSearchPlaceholder: "Быстрый поиск по ключу или комментарию",
    defaultAdminPosition: "Операционный администратор",

    orderId: "ID заказа",
    total: "Итого",
    status: "Статус",
    cartItems: "Товары в корзине",
    logout: "Выйти",
    changePasswordAction: "Сменить пароль",
    userPasswordModalTitle: "Изменить пароль пользователя",
    userPasswordUpdated: "Пароль пользователя успешно обновлён.",
    targetUser: "Целевой пользователь",
    userDataResyncedHint: "После сохранения обнаружено обновление полей со стороны сервера. Данные синхронизированы заново.",
    userManagementRestrictedHint: "Для этого действия требуются более высокие права.",

    capability: {
      "admin:overview:read": "Чтение обзора администратора",
      "admin:products:read": "Чтение товаров администратора",
      "admin:products:write": "Запись товаров администратора",
      "admin:orders:read": "Чтение заказов администратора",
      "admin:orders:write": "Запись заказов администратора",
      "admin:users:read": "Чтение пользователей администратора",
      "admin:users:role:write": "Изменение ролей пользователей",
      "admin:users:position:assign": "Назначение позиций пользователям",
      "admin:storefront:read": "Чтение настроек storefront",
      "admin:storefront:write": "Изменение настроек storefront",
      "admin:system-config:read": "Чтение системной конфигурации",
      "admin:system-config:write": "Изменение системной конфигурации",
      "shop:profile:read": "Чтение профиля магазина",
      "shop:password:write": "Изменение пароля магазина",
      "shop:orders:read": "Чтение заказов магазина",
      "shop:inquiry:write": "Обработка запросов магазина",
      "shop:wishlist:read": "Чтение списка желаний",
      "shop:orders:processing:read": "Чтение обработки заказов",
      "shop:after-sales:read": "Чтение after-sales",
      "internal:work:targets:read": "Чтение рабочих целей",
      "internal:work:processing:read": "Чтение обработки работы",
      "internal:maintenance:site:write": "Изменение обслуживания сайта",
      "internal:maintenance:permission:write": "Изменение обслуживания прав",
      "internal:maintenance:position:write": "Изменение обслуживания позиций",
      "shop:products:read": "Чтение товаров магазина",
      "shop:storefront:read": "Чтение storefront магазина",
      "internal:system:config:read": "Чтение внутренней системной конфигурации",
      "internal:system:config:write": "Изменение внутренней системной конфигурации",
      "internal:security:audit:read": "Чтение аудита безопасности",
      "internal:security:session:revoke": "Отзыв сессии",
      "internal:integration:manage": "Управление интеграциями",
      "admin:users:write": "Изменение пользователей администратора",
      "admin:users:password:reset": "Сброс пароля пользователя",
      "admin:users:delete": "Удаление пользователя администратора",
      "crm:customer:read": "Чтение профиля клиента",
      "crm:customer:write": "Изменение профиля клиента",
      "crm:customer:assign": "Назначение владельца клиента",
      "website:content:read": "Чтение контента сайта",
      "website:content:write": "Изменение контента сайта",
      "website:navigation:write": "Изменение навигации сайта",
      "website:banner:write": "Изменение баннеров сайта",
      "website:seo:write": "Изменение SEO сайта",
      "website:theme:write": "Изменение темы сайта",
      "website:publish": "Публикация контента сайта",
      "admin:products:create": "Создание товаров администратора",
      "admin:products:delete": "Удаление товаров администратора",
      "merchandising:selection:read": "Чтение пула отбора",
      "merchandising:selection:write": "Изменение пула отбора",
      "catalog:pricing:write": "Изменение цен каталога",
      "catalog:inventory:write": "Изменение остатков каталога",
      "catalog:translation:write": "Изменение переводов каталога",
      "sales:inquiry:read": "Чтение sales-запросов",
      "sales:inquiry:reply": "Ответ на sales-запрос",
      "sales:quotation:create": "Создание sales-предложения",
      "sales:quotation:approve": "Утверждение sales-предложения",
      "sales:contract:write": "Изменение sales-контракта",
      "sales:sample:manage": "Управление workflow образцов",
      "order:status:update": "Обновление статуса заказа",
      "order:split:merge": "Разделение/объединение заказов",
      "procurement:purchase:write": "Изменение заказов на закупку",
      "production:plan:write": "Изменение производственных планов",
      "qa:inspection:write": "Изменение инспекций качества",
      "logistics:shipment:write": "Изменение данных отгрузки",
      "logistics:tracking:read": "Чтение логистического трекинга",
      "trade:customs:doc:write": "Изменение таможенных документов",
      "finance:invoice:read": "Чтение счетов",
      "finance:invoice:write": "Изменение счетов",
      "finance:payment:read": "Чтение платежей",
      "finance:payment:write": "Изменение платежей",
      "finance:refund:approve": "Утверждение возврата",
      "finance:reconciliation:write": "Изменение финансовой сверки",
      "finance:tax:write": "Изменение налоговой информации",
      "marketing:campaign:read": "Чтение маркетинговых кампаний",
      "marketing:campaign:write": "Изменение маркетинговых кампаний",
      "marketing:coupon:write": "Изменение купонов",
      "marketing:lead:export": "Экспорт лидов",
      "analytics:dashboard:read": "Чтение аналитической панели",
      "analytics:report:export": "Экспорт аналитических отчётов",
      "support:ticket:read": "Чтение support-тикетов",
      "support:ticket:write": "Изменение support-тикетов",
      "support:return:approve": "Утверждение запроса на возврат",
      "support:complaint:handle": "Обработка жалоб клиентов",
      "office:announcement:write": "Изменение объявлений офиса",
      "office:document:read": "Чтение офисных документов",
      "office:document:write": "Изменение офисных документов",
      "office:workflow:approve": "Утверждение офисного workflow",
      "office:meeting:manage": "Управление расписанием встреч",
      "hr:employee:read": "Чтение записей сотрудников",
      "hr:employee:write": "Изменение записей сотрудников"
    }
  }
};